import './oligo-summary-bar-manager.scss';

function isElementInViewport(rect: ClientRect, $window: ng.IWindowService, documentElement: HTMLElement) {
  // we're only concerned whether the element is contained
  // within the vertical boundaries of the window
  return (
      rect.top >= 0 &&
      rect.top <= ($window.innerHeight || documentElement.clientHeight)
  );
}

class OligoSummaryBarManagerController implements ng.IComponentController {
  public floatingBarVisible: boolean = true;
}

export const OLIGO_SUMMARY_BAR_MANAGER_NAME: string = 'oligoSummaryBarManager';
export const OligoSummaryBarManager: ng.IDirectiveFactory = ($document: ng.IDocumentService,
                                                             $window: ng.IWindowService,
                                                             $compile: ng.ICompileService): ng.IDirective<ng.IScope> => {
  return {
    template: require('./oligo-summary-bar-manager.tpl.html'),
    controller: OligoSummaryBarManagerController,
    controllerAs: 'oligoSummaryManager',
    transclude: true,
    scope: {
      onCartStateChange: '&',
      cartProcessing: '<',
    },
    bindToController: true,
    link: ($scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl?: ng.IController) => {
      // We render two oligo-summary-bars. One that floats and one that sticks
      // to the footer. The floating bar we hide when the permanent bar starts
      // to show up
      const controller: OligoSummaryBarManagerController = ctrl as OligoSummaryBarManagerController;
      const document: Document = $document[0];
      const documentElement: HTMLElement = document.documentElement as HTMLElement;
      let footerJQ: JQuery<Element> = $document.find('.globalFooter .footer');
      if (footerJQ.length <= 0) {
        footerJQ = $document.find('.footer');
      }
      const footer: Element | null = footerJQ[0];
      if (footer) {
        const oligoSummaryBarPermTemplate = `
        <oligo-summary-bar class="oligo-summary-bar__permanent"
                           cart-processing="oligoSummaryManager.cartProcessing"
                           on-cart-state-change="oligoSummaryManager.onCartStateChange({state})">
        </oligo-summary-bar>`;
        const linkFn: ng.ITemplateLinkingFunction = $compile(oligoSummaryBarPermTemplate);
        const content: JQLite = linkFn($scope);
        footerJQ.before(content);
        const summaryBarHeight: number = content[0].getBoundingClientRect().height;
        content.find('.loader-container')
               .css('height', `${summaryBarHeight}px`)
               .css('top', `-${summaryBarHeight}px`);
        const hideFloatingBar: () => void = () => {
          const footerRect: ClientRect = footer.getBoundingClientRect();
          const footerVisible: boolean = isElementInViewport(footerRect, $window, documentElement);
          $scope.$apply(() => {
            controller.floatingBarVisible = !footerVisible;
          });
        };
        const watchVerticalScroll: () => void = (() => {
          let lastScrollHeight: number = documentElement.scrollHeight;
          return () => {
            const newScrollHeight: number = documentElement.scrollHeight;
            if (lastScrollHeight !== newScrollHeight) {
              lastScrollHeight = newScrollHeight;
              hideFloatingBar();
            }
          };
        })();
        const intervalId: number = $window.setInterval(watchVerticalScroll, 200);
        $document.on('scroll', hideFloatingBar);
        $window.addEventListener('resize', hideFloatingBar);
        $scope.$on('$destroy', () => {
          $document.off('scroll', hideFloatingBar);
          $window.removeEventListener('resize', hideFloatingBar);
          $window.clearInterval(intervalId);
        });
      }
    },
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/oligo-summary-bar-manager/oligo-summary-bar-manager.ts